<template>
  <div class="date-picker-flex">
    <el-date-picker
      type="date"
      v-model="query.beginTime"
      placeholder="选择开始时间"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      :picker-options="handleStartDate"
      :size="size"
      :style="{width: width}"
      @change="handleChange(1)"
    />

    <span class="margin-left-8 margin-right-8">至</span>

    <el-date-picker
      type="date"
      v-model="query.endTime"
      placeholder="选择结束时间"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      :picker-options="handleEndDate"
      :size="size"
      :style="{width: width}"
      @change="handleChange(2)"
    />
  </div>
</template>
<script>
export default {
  props: {
    // 参数
    query: {
      type: [Object, String],
      required: true,
      default: () => ({
        beginTime: '',
        endTime: '',
      }),
    },
    /**
     * 时间限制；
     * limitOld=限制只能选择今天以及今天之前的 ，默认
     * limitToday=限制只能选择今天以及今天之后的，
     * limitTomorrow=限制只能选择明天以及之后的，
     * limitMonth=限制只能选择今天之前或选中日期到当前日期（最多limitMonth个月范围）
     * none= 不做限制
     * limitDay 限制多少天内
    */
    limit: {
      type: String,
      default: 'limitOld',
    },
    /**
     * 限制月数范围
     */
    limitMonth: {
      type: Number,
      default: 1,
    },
    /**
     * 限制天数
     */
    limitDay: {
      type: Number,
      default: 30,
    },
    // 尺寸 medium / small / mini
    size: {
      type: String,
      default: 'medium',
    },
    // 尺寸 medium / small / mini
    width: {
      type: String,
      default: '150px',
    },
  },
  data() {
    const that = this;
    return {
      // 限制只能选择今天以及今天之前的
      startDateOldOption: {
        disabledDate(time) {
          if (that.query.endTime !== null && that.query.endTime !== '') {
            return time.getTime() > new Date(that.query.endTime).getTime();
          }
          return time.getTime() > Date.now();
        },
      },
      // 限制只能选择今天以及今天之前的
      endDateOldOption: {
        disabledDate(time) {
          return time.getTime() > Date.now() || time.getTime()
            <= new Date(that.query.beginTime).getTime() - 8.64e7;
        },
      },

      // 限制只能选择今天以及今天之后的
      startDateTodayOption: {
        disabledDate(time) {
          if (that.query.endTime !== null && that.query.endTime !== '') {
            return time.getTime() > new Date(that.query.endTime).getTime();
          }
          return time.getTime() < Date.now();
        },
      },
      // 限制只能选择今天以及今天之后的
      endDateTodayOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() || time.getTime()
            <= new Date(that.query.beginTime).getTime() - 8.64e7;
        },
      },
    };
  },

  computed: {
    // 开始时间限制
    handleStartDate() {
      const list = {
        limitOld: this.startDateOldOption,
        limitToday: this.startDateTodayOption,
        limitMonth: this.getStartDataMonthOption(this.limitMonth),
        limitDay: this.getStartDateDayOption(this.limitDay),
        none: false,
      };
      return list[this.limit] || false;
    },
    // 结束时间限制
    handleEndDate() {
      const list = {
        limitOld: this.endDateOldOption,
        limitToday: this.endDateTodayOption,
        limitMonth: this.getEndDateOneMonthOption(this.limitMonth),
        limitDay: this.getEndDateDayOption(this.limitDay),
        none: false,
      };
      return list[this.limit] || false;
    },
  },

  methods: {
    handleChange(type) {
      this.$emit('change', type);
    },
    // 限制只能选择今天之前或选中日期到当前日期（month个月）
    getStartDataMonthOption(month) {
      const that = this;
      return {
        disabledDate(time) {
          const choiceDateTime = new Date(that.query.endTime).getTime();
          const minTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() - month);
          const maxTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() + month);
          if (that.query.endTime !== null && that.query.endTime !== '') {
            return time.getTime() < minTime || time.getTime() > maxTime || time.getTime() >= choiceDateTime;
          }
          return time.getTime() > Date.now();
        },
      };
    },
    // 限制只能选择今天之前或选中日期到当前日期（month个月）
    getEndDateOneMonthOption(month) {
      const that = this;
      return {
        disabledDate(time) {
          const choiceDateTime = new Date(that.query.beginTime).getTime();
          const minTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() - month);
          const maxTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() + month);
          const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - month;
          const max = newDate < maxTime ? newDate : maxTime;
          if (that.query.beginTime !== null && that.query.beginTime !== '') {
            return time.getTime() < minTime || time.getTime() > max || time.getTime() <= choiceDateTime - 8.64e7;
          }
          return time.getTime() > Date.now();
        },
      };
    },
    // 限制只能选择今天之前或选中日期到当前日期（day天）
    getStartDateDayOption(day) {
      const that = this;
      return {
        disabledDate(time) {
          const choiceDateTime = new Date(that.query.endTime).getTime();
          if (that.query.endTime !== null && that.query.endTime !== '') {
            const days = day * 24 * 60 * 60 * 1000;
            return time.getTime() < choiceDateTime - days || time.getTime() > choiceDateTime + days || time.getTime() >= choiceDateTime;
          }
          return time.getTime() > Date.now();
        },
      };
    },
    // 限制只能选择今天之前或选中日期到当前日期（day天）
    getEndDateDayOption(day) {
      const that = this;
      return {
        disabledDate(time) {
          const choiceDateTime = new Date(that.query.beginTime).getTime();
          if (that.query.beginTime !== null && that.query.beginTime !== '') {
            const days = day * 24 * 60 * 60 * 1000;
            const max = choiceDateTime + days - 8.64e7;
            const min = choiceDateTime - days - 8.64e7;
            return time.getTime() <= choiceDateTime - 8.64e7 || time.getTime() > max || time.getTime() < min;
          }
          return time.getTime() > Date.now();
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.date-picker-flex {
  display: flex;
  align-items: center;
}
</style>
